import React, { useCallback, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Card, Button, Spinner, Form } from "react-bootstrap";
import PageTitle from "../../Components/PageTitle";
import { useTranslation } from "react-i18next";
import { getHydrantListById, saveHydrantData, updateHydrantData } from "../../redux/actions/HydrantActions";
import FormInput from "../../Components/FormInput";
import { useNavigate, useParams } from "react-router-dom";
import { logout } from "../../redux/actions/AuthActions";
import { toast } from "react-toastify";
import Select from "react-dropdown-select";
import swal from 'sweetalert2';
import LeafletSingleMap from "../../Components/LeafletSingleMap";
import { getAddressByLatLng, getAllUsertypeUserList } from "../../redux/actions/MasterActions";
import Preloader from "../../Components/Preloader";
import { getLiveTracking } from "../../redux/actions/MapActions";
import LeafletMapAllVehicle from "../../Components/LeafletMapAllVehicle";
import { useSocketContext } from "../../Context/SocketContext";

const LiveTrack = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    latitude: 0.00,
    longitude: 0.00
  });
  const dispatch = useDispatch();
  const {
    AuthReducer: { auth, loading, errors },
    mapReducer: {
      liveTrackingData,
      vehicleCount,
      loadingMap,
      errorsMap,
    }
  } = useSelector((state) => state);


  const { socket } = useSocketContext();

  useEffect(() => {
    // Function to fetch live tracking data (only initial fetch, no interval)
    const fetchLiveTracking = () => {
      dispatch(getLiveTracking(auth?.accessToken));
    };

    // Initial fetch only
    fetchLiveTracking();
  }, [auth, dispatch]);

  // Listen for vehicle location updates via socket
  useEffect(() => {
    if (!socket) return;

    const handleVehicleLocationUpdate = (vehicleData) => {
      // Dispatch action to update vehicle location in Redux
      dispatch({
        type: "UPDATE_VEHICLE_LOCATION",
        payload: vehicleData,
      });
    };

    // Listen for vehicle location updates
    socket.on("vehicleLocationUpdate", handleVehicleLocationUpdate);

    // Cleanup on unmount
    return () => {
      socket.off("vehicleLocationUpdate", handleVehicleLocationUpdate);
    };
  }, [socket, dispatch]);


  useEffect(() => {
    if (errors && Object.keys(errors).length > 0) {
      if (errors?.status === 401) {
        dispatch(logout());
        toast.error(errors?.data?.message);
        navigate('/login');
        window.location.reload();
      }
    }
  }, [errors, dispatch, navigate]);

  useEffect(() => {
  }, [liveTrackingData])

  return (
    <>
      <PageTitle
        breadCrumbItems={[
          { label: t("Live Tracking"), path: "/Live-Tracking", active: true },
        ]}
        title={t("Live Tracking")}
      />
      <Row>
        <Col lg={12}>
          <Card>
            <Card.Body>
              <div style={{ position: "relative", overflow: "hidden", height: "600px" }}>
                <LeafletMapAllVehicle
                  mapHeight={"600px"}
                  vehicleData={liveTrackingData}
                />
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      {loadingMap && (<Preloader />)}
    </>
  );
};

export default LiveTrack;
